module.exports = __webpack_public_path__ + "static/media/mainBackground.90f66fd9.png";